import createApiService from "../../http";

const SEARCH_ENDPOINT = "search";

export const searchService = (params) =>
  createApiService({
    method: "get",
    endpoint: SEARCH_ENDPOINT,
    options: {
      params: {
        ...params,
        noCache: true,
      },
    },
  });
